import React from "react";
import { flatten } from "@merncloud/permission-resolver";
import { getPermissionClient } from "@merncloud/permission-resolver/frontend";
import { useUser } from "../../services/useUser";

type Props = {};

const resource = {
  id: "1",
  type: "contract",
  attributes: {
    department: "engineering",
  },
};

const SettingsPage = (props: Props) => {
  const subject = useUser();
  const canRead = getPermissionClient().can(subject, resource, "read");
  const canWrite = getPermissionClient().can(subject, resource, "write");
  const rules = getPermissionClient().getRules();
  const capabilities = flatten(subject, resource);

  return (
    <div>
      <div>{canRead && <p>User can read the resource.</p>}</div>
      <div>{canWrite ? <button>Edit</button> : <p>No edit access</p>}</div>
      <div>
        Rules:
        {JSON.stringify(rules)}
      </div>
      <div>
        Capabilities:
        {JSON.stringify(capabilities)}
      </div>
    </div>
  );
};

export default SettingsPage;
